'use client'

import Head from 'next/head'

import PricingPanel from '@/components/pricing/PricingPanel'

const Pricing = () => {
  return (
    <>
      <Head>
        <title>Pricing</title>
        <meta name="description" content="Pricing" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <PricingPanel />
    </>
  )
}

export default Pricing
